export default "__VITE_ASSET__DlT44aRQ__"